import { gql } from '@apollo/client/core'

/**
 * DETAIL QUERY
 * Fetches full info for editing
 */
export const DETAIL_QUERY = gql`
  query GetEntityConfig ($entityType: String, $entityId: String) {
    item: entityconfigByFields (filter: { entityId: $entityId, entityType: $entityType , isDeleted: false }) {
        timeCreated
        entityType
        entityId
        entityPath
        priority
        mfa
        subsystemAccess
        _id
    }
  }
`

export const SUMMARY_QUERY = gql`
  query GetEntityConfig {
    items: entityconfigsByFields {
        isDeleted
        timeCreated
        entityId
        entityPath
        priority
        mfa
        _id
        entityType
        subsystemAccess
    }
  }
`

/**
 * CREATE MUTATION
 */
export const CREATE_MUTATION = gql`mutation entityconfigCreateOne($record: CreateOneEntityConfigInput!) { saveItem: entityconfigCreateOne(record: $record) { recordId } }`

/**
 * UPDATE MUTATION
 * Note: The returned fields should only inclu1 those managed by the user privilege.
 * Some fields such as Path, iden, should not be editable by user admins and thus are not returned here to avoid confusion.
 */
export const UPDATE_MUTATION = gql`
  mutation UpdateEntityConfig($id: MongoID!, $record: UpdateByIdEntityConfigInput!) {
    saveItem: entityconfigUpdateById(id: $id, record: $record) {
        recordId
        record {  
            timeCreated
            entityType
            entityId
            entityPath
            priority
            mfa
            subsystemAccess
            _id
        }
    }
  }
`

/**
 * DELETE MUTATION
 */
export const DELETE_MUTATION = gql`
  mutation RemoveEntityConfig($_id: MongoID!) {
    entityconfigRemoveById( _id: $_id ){
    recordId
    }
  }
`
